import React, { useContext, useMemo } from "react";

//Highcharts
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import HighchartsItemSeries from "highcharts/modules/item-series";

//Context
import DataHandling from "../../utils/dataHandling";
import {
  config_lineChartEV,
} from "../../models/diagramsConfig";
import { GetDataContext } from "../../context/GetDataContext";

//Highcharts Modules
HighchartsItemSeries(Highcharts);

const RegressionV2 = () => {
  //Data
  const {
    evData,
    appConfigOptions,
  } = useContext(GetDataContext);
  //Filtering
  const filter = {value: 0, label: 'ΟΛΕΣ ΟΙ ΕΤΑΙΡΙΕΣ'}; // Hard coded filter object with zero because we need all companies

  useMemo(() => {
    if (evData.data.length > 0) {
        DataHandling(evData, filter, appConfigOptions)
    }
  }, [ evData, appConfigOptions]);

  return (
    <div className="regression">
      <header className="widget-header--politics">
        <a href="https://www.news247.gr/pollitics/">
          <h2 className="politics__header">
          </h2>
        </a>

        <h3 className="politics__subtitle">Η ΚΑΘΑΡΗ ΜΑΤΙΑ ΣΤΙΣ ΔΗΜΟΣΚΟΠΗΣΕΙΣ</h3>
        <h2 className="politics__description">Οι εκλογικές τάσεις όπως αποτυπώνονται στο σύνολο των ερευνών</h2>
      </header>
      <section className={"container container-evaluation"}>
        <HighchartsReact
          highcharts={Highcharts}
          options={config_lineChartEV}
          updateArgs={[true, true, true]}
        />
      </section>
        <div className="politics__infos">
          <span>*Η ΕΚΤΙΜΗΣΗ ΨΗΦΟΥ ΠΡΟΚΥΠΤΕΙ ΣΥΜΦΩΝΑ ΜΕ ΤΟ MOVING AVERAGE ΤΩΝ ΤΕΛΕΥΤΑΙΩΝ 10 ΔΗΜΟΣΚΟΠΗΣΕΩΝ</span>
        </div>
        <div className="politics__footer">
          <a className="politics__button" href="https://www.news247.gr/pollitics/" target="_self">ΔΕΙΤΕ ΠΕΡΙΣΣΟΤΕΡΑ</a>
        </div>
    </div>
  );
};

export default RegressionV2;
